import React from 'react';
import styles from './RoundTab.css';

const RoundTab = ({ title, num, isActive, onClick }) => (
  <a
    className={isActive ? styles.roundTabActive : styles.roundTab}
    onClick={onClick}
    data-ga-on="click"
    data-ga-event-category="Awards"
    data-ga-event-action={title}
  >
    <span className={styles.title}>{title}</span>
    <span className={styles.num}>{num}</span>
  </a>
);

export default RoundTab;



// WEBPACK FOOTER //
// ./src/components/RoundTab/index.js